import httpclient from 'libs/Axios/index';

type FetchBlogsParams = {
    institute_id: number;
    branch_id: number;
    publish_filter?: string;
    page?: number;
    page_size?: number;
    search?: string;
};

export const blogApi = {
    fetchBlogs(params: FetchBlogsParams) {
        const {
            page = 1,
            page_size = 9,
            publish_filter,
            search,
        } = params;
        const queryParams = new URLSearchParams({
            page_index: String(page),
            page_size: String(page_size),
        });

        if (publish_filter && publish_filter !== 'both') {
            queryParams.set('publish_filter', publish_filter);
        }

        if (search) {
            queryParams.set('search', search);
        }

        return httpclient().get(`/master/blog/list?${queryParams.toString()}`);
    },

    fetchBlogById(id: number) {
        return httpclient().get(`/master/blog/view?blog_id=${id}`);
    },

    upsertBlog(payload: any) {
        return httpclient().post('/master/upsert/blog', payload);
    },

    publishBlog(blogId: number) {
        return httpclient().post(`/master/blog/publish?blog_id=${blogId}`);
    },

    deleteBlog(id: number) {
        return httpclient().delete(`/master/blog/delete?blog_id=${id}`);
    },

    generateAIText(payload: { title: string; description: string }) {
        return httpclient().post('/master/blog_content/generate', payload);
    },

    generateAIImage(payload: { title: string; description: string }) {
        return httpclient().post('/master/blog/image/generate', payload);
    },

    enhanceImage(payload: {
        user_image_url: string;
        face_upsample: boolean;
        background_enhance: boolean;
        upscale: number;
        fidelity_weight: number;
    }) {
        return httpclient().post('/master/fr/imageEnhance', payload);
    },

    getGeneratedImage(taskId: string) {
        return httpclient().get(`/master/fr/getImage?task_id=${taskId}`);
    },
};
